import React, { useState } from 'react';
import moment from 'moment'

import { getGroupsConfigurations, checkGroupsConfigurationsForUpdates } from '../services/GetGroupsDetails'

export const GroupsImagesContext = React.createContext({
  getSetGroupsConfigurations: () => { },
})

function GroupsImagesRepository({ children }) {

  const [groupsConfigurations, innerSetGroupsConfigurations] = useState(
    localStorage.getItem('groupsConfigurations') ? JSON.parse(localStorage.getItem('groupsConfigurations')) : {}
  );

  const [groupsConfigurationsLastUpdate, innerSetGroupsConfigurationsLastUpdate] = useState(localStorage.getItem('groupsConfigurationsLastUpdate') || 0)

  function setGroupsConfigurations(configs) {
    localStorage.setItem('groupsConfigurations', JSON.stringify(configs))
    innerSetGroupsConfigurations(configs)

    const lastUpdate = moment().unix()
    localStorage.setItem('groupsConfigurationsLastUpdate', lastUpdate)
    innerSetGroupsConfigurationsLastUpdate(lastUpdate)
  }

  function getSetGroupsConfigurations() {
    return new Promise((res, rej) => {
      // check if new version of configs!
      checkGroupsConfigurationsForUpdates(groupsConfigurationsLastUpdate)
        .then(hasNewConfigurations => {
          if (!hasNewConfigurations && Object.keys(groupsConfigurations).length > 0) {
            return res(groupsConfigurations);
          }
          getGroupsConfigurations()
            .then(results => {
              const groupsConfigurationsObject = createObjectByKey(results.groupsConfigurations, 'groupId')
              setGroupsConfigurations(groupsConfigurationsObject)
              return res(groupsConfigurationsObject);
            })
        })
    })
  }

  return (
    <GroupsImagesContext.Provider
      value={{
        groupsConfigurations,
        getSetGroupsConfigurations,
      }}
    >
      {children}
    </GroupsImagesContext.Provider>
  );
}

export const GroupsImagesContextConsumer = (WrappedComponent) => (props) => {

  return (
    <GroupsImagesContext.Consumer>
      {context => <WrappedComponent context={context} {...props} />}
    </GroupsImagesContext.Consumer>
  )
}

export default GroupsImagesRepository;

function createObjectByKey(array, key) {
  if (array.length === 0) return {}
  return array.reduce((curr, value) => {
    curr[value[key]] = value
    return curr
  }, {})
}